"use client";
import React, { useEffect } from "react";

interface IProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const BottomSheet: React.FC<IProps> = ({ open, onClose, children }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className={`fixed inset-0 z-50 ${open ? "pointer-events-auto" : "pointer-events-none"}`}>
      {/* Overlay */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${
          open ? "opacity-60" : "opacity-0"
        }`}
        onClick={onClose}
      ></div>

      {/* Bottom Sheet */}
      <div
        className={`absolute bottom-0 left-0 max-h-[80%] w-full overflow-y-auto bg-white shadow-lg transition-transform duration-300 ${
          open ? "translate-y-0" : "translate-y-full"
        }`}
      >
        {/* Content */}
        {children}
      </div>
    </div>
  );
};

export default BottomSheet;
